import _createIconComponent from "./utils/createIconComponent";
const _createIconComponent2 = _interopRequireDefault(_createIconComponent);
import _react from "react";
const _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

const IconLockedHexagon = _createIconComponent2.default({
  content: _react2.default.createElement(
    "g",
    null,
    _react2.default.createElement("path", {
      d: "M12.5 0L25 7V21L12.5 28L0 21V7L12.5 0Z",
      fill: "#99B2C4",
    }),
    _react2.default.createElement("path", {
      d: "M12.9996 6C15.9996 6 17.5709 8 17.5709 10.5V11.7148H18.857C19.4093 11.7148 19.857 12.1626 19.857 12.7148V19.8574C19.8569 20.4096 19.4092 20.8574 18.857 20.8574H7.14314C6.59094 20.8574 6.14329 20.4096 6.14314 19.8574V12.7148C6.14314 12.1626 6.59085 11.7148 7.14314 11.7148H8.42829V10.5C8.42829 8.00012 9.99986 6.00019 12.9996 6ZM12.9996 15.1426C12.3686 15.1428 11.857 15.6551 11.857 16.2861C11.8572 16.917 12.3687 17.4285 12.9996 17.4287C13.6306 17.4287 14.1429 16.9171 14.1431 16.2861C14.1431 15.655 13.6308 15.1426 12.9996 15.1426ZM12.9996 8.28613C11.9997 8.28635 10.7145 9.07159 10.7144 10.5713V11.7148H15.2857V10.5C15.2857 9 13.9996 8.28613 12.9996 8.28613Z",
      fill: "#002F50",
    })
  ),
  height: 28,
  width: 25,
});

IconLockedHexagon.displayName = "IconLockedHexagon";
const _default = IconLockedHexagon;
export { _default as default };
